export const getCustomerByIdRequest = (id) => {
  return {
    url: `/api/Customer/${id}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
};

export const getPostCustomerRequest = (payload) => {
  return {
    url: "/api/Customer",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
};

export const getRegisterCustomerRequest = (payload) => {
  return {
    url: "/api/Customer/register",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
};

export const getUpdateRequest = (payload) => {
  return {
    url: "/api/Customer/",
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
};

export const getRequestGetCustomers = () => {
  return {
    url: "/api/Customer",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
};

/**
 * `getRequestDeleteCustomer` will return DEL request for removing customer.
 */
export const getRequestDeleteCustomer = (id) => {
  return {
    url: `api/Customer/${id}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  };
};
